<template>
  <Layout>
    <PageHeader :title="title" :items="items"></PageHeader>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-form @submit.prevent="submitData">
              <div
                class="d-flex flex-wrap justify-content-between align-items-center mb-2"
              >
                <div class="d-flex align-items-center">
                  <label class="mb-0">Prescription</label>
                </div>
                <div>
                  <span
                    class="badge badge-info p-1 mr-2"
                    style="cursor: pointer"
                    @click="openPreviewInNewTab"
                  >
                    Open in New Tab
                  </span>
                  <span
                    v-if="form.html"
                    class="badge badge-secondary p-1"
                    style="cursor: pointer"
                    @click="printPrescription()"
                  >
                    Print
                  </span>
                </div>
              </div>

              <!-- The rendered prescription is itself the editor -->
              <div class="row">
                <div class="col-12">
                  <html-preview
                    ref="preview"
                    v-model="form.html"
                    editable
                  ></html-preview>
                  <small class="text-muted d-block mt-1">
                    Click into the prescription and type to edit it.
                  </small>
                </div>
              </div>

              <div class="mt-3">
                <b-button type="submit" variant="primary" class="mr-2">
                  Update
                </b-button>
                <b-button variant="light" @click="$router.push({ name: 'aria' })">
                  Cancel
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../mixins/request";
import ariaMixin from "../../../mixins/ModuleJs/aria";
import HtmlPreview from "./HtmlPreview";

export default {
  mixins: [MixinRequest, ariaMixin],
  components: {
    Layout,
    PageHeader,
    HtmlPreview,
  },
  data() {
    return {
      title: "Edit Prescription",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Digital Prescriptions",
          href: "/aria",
        },
        {
          text: "Edit",
        },
      ],
    };
  },
};
</script>
